<template>
  <div class="nq5c-zt" id="nq5c-zt">
    <ShareBar></ShareBar>
    <Header v-if="!minip2"></Header>
    <div
      class=""
      :class="
        documentHeight > 800 && documentWidth > 768
          ? 'nq5c-wraper small-computer'
          : 'nq5c-wraper'
      "
    >
      <div class="calculator-header" :class="minip2 ? '' : 'sticky-top'">
        <h2>金融计算器</h2>
        <h3>
          为您提供更便捷购车工具，搜索您附近经销商门店，估算付款金额，获享心仪车型座驾
        </h3>
      </div>
      <div class="c-wraper" :style="{ 'margin-top': minip2 ? '0px' : '60px' }">
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
            <el-form
              ref="form"
              :model="form"
              label-width="80px"
              label-position="top"
              style="padding-top: 30px"
              :style="{ 'padding-top': minip2 ? '0px' : '30px' }"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item
                    :label="
                      documentHeight >= 800 || documentWidth < 768 ? '车型' : ''
                    "
                  >
                    <el-select
                      v-model="carTypeId"
                      placeholder="请选择车型"
                      @change="changeSersice"
                    >
                      <template slot="prefix" v-if="documentHeight < 800">
                        <div class="s-label">车型:</div>
                      </template>
                      <el-option
                        v-for="item in carList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="1" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item
                    :label="
                      documentHeight >= 800 || documentWidth < 768 ? '配置' : ''
                    "
                  >
                    <el-select
                      v-model="form.id"
                      placeholder="请选择配置"
                      @change="changeModel"
                    >
                      <template slot="prefix" v-if="documentHeight < 800">
                        <div class="s-label">配置:</div>
                      </template>
                      <el-option
                        v-for="item in carModelList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="贷款方案">
                <el-row class="dk-wraper">
                  <img
                    @click="prev"
                    class="icon-arrow"
                    src="../assets/images/arrow-left.png"
                    alt=""
                    :code-stm="`event, PAGEURL, 金融计算器_贷款方案_${currentProName}`"
                  />
                  <el-carousel
                    class="banner"
                    ref="carousel"
                    trigger="click"
                    arrow="always"
                    height="90px"
                    :autoplay="false"
                    @change="selectCaret"
                  >
                    <el-carousel-item
                      v-for="(item, index) in loanPlan"
                      :key="index"
                    >
                      <div class="carousel-item-wraper">
                        <h3 class="small">{{ currentProName }}</h3>
                        <el-row class="progress-price-tips"
                          ><span class="subTitle" v-if="subTips">{{
                            subTips
                          }}</span
                          ><span :class="!subTips ? 'l-height' : ''">{{
                            tipsText
                          }}</span></el-row
                        >
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                  <img
                    @click="next"
                    class="icon-arrow"
                    src="../assets/images/arrow-right.png"
                    alt=""
                    :code-stm="`event, PAGEURL, 金融计算器_贷款方案_${currentProName}`"
                  />
                </el-row>
              </el-form-item>
              <el-form-item label="首付比例">
                <el-row class="progress-price">
                  <el-col
                    style="text-align: left"
                    :xs="3"
                    :sm="3"
                    :md="2"
                    :lg="2"
                    :xl="2"
                    >{{ firstProportion }}%</el-col
                  >
                  <el-col :xs="13" :sm="13" :md="16" :lg="16" :xl="18"
                    ><el-slider
                      :show-tooltip="false"
                      @change="changeslider"
                      :disabled="
                        currentProduction[0].loanProductsTypeName == 'FLEX'
                      "
                      :min="firstProportion"
                      :max="80"
                      v-model="form.firstProportion"
                    ></el-slider
                  ></el-col>
                  <el-col
                    style="text-align: center"
                    :xs="3"
                    :sm="3"
                    :md="2"
                    :lg="2"
                    :xl="2"
                    >80%</el-col
                  >
                  <el-col :xs="5" :sm="5" :md="4" :lg="4" :xl="4">
                    <el-input
                      :disabled="
                        currentProduction[0].loanProductsTypeName == 'FLEX'
                      "
                      placeholder=""
                      v-model="form.firstProportion"
                      @change="changeStep"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="贷款期限">
                <el-row class="btn-wraper">
                  <el-button
                    v-for="(item, index) in currentProduction"
                    :type="item.loanMonth == form.loanMonth ? 'primary' : ''"
                    @click="selectProduction(item)"
                    :key="index"
                    >{{ item.loanMonth }}期</el-button
                  >
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" v-loading="loading"
            ><div
              class="grid-content bg-purple-light"
              v-if="documentHeight < 800"
            >
              <img :src="coverImg" alt="" />
              <div class="flex-right">
                <div class="c-content-item" style="padding-bottom:7px">
                  <div>
                    <span class="car-label" style=" white-space: nowrap;">车辆：</span>
                    <span class="">{{ carName }} </span>{{ carModelName }}
                  </div>
                </div>
                <div class="c-content-item">
                  <div>
                    <span class="car-label">官方指导价：</span>
                    <span class="red">
                      ¥{{
                        (form.guidePrice + "").replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ","
                        ) || 0.0
                      }}
                    </span>

                    <p v-if="hasOptional">含个性化配置价格</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple-light" v-else>
              <img :src="coverImg" alt="" />
            </div>
            <div :class="specStype ? 'c-content c-content-jt' : 'c-content'">
              <div class="c-content-item" v-if="documentHeight >= 800">
                <div class="car-label" style=" white-space: nowrap;">车辆：</div>
                <div>
                  <span class="">{{ carName }} </span>{{ carModelName }}
                </div>
              </div>
              <div class="c-content-item" v-if="documentHeight >= 800">
                <div class="car-label">官方指导价：</div>
                <div>
                  <span class="red">
                    ¥{{
                      (form.guidePrice + "").replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      ) || 0.0
                    }}
                  </span>

                  <p v-if="hasOptional">含个性化配置价格</p>
                </div>
              </div>

              <h4 class="h4">
                {{ currentProName }}
              </h4>
              <div class="c-content-item">
                <div>首付金额</div>
                <div class="red">
                  ¥{{
                    (productionInfo.firstPayment + "").replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ","
                    ) || 0.0
                  }}
                </div>
              </div>
              <div
                class="c-content-item"
                v-if="!productionInfo.oneMonthlypayment"
              >
                <div>1-{{ form.loanMonth }}期月供金额</div>
                <div class="red">
                  ¥{{
                    (productionInfo.monthlySupply + "").replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ","
                    ) || 0.0
                  }}
                </div>
              </div>
              <div v-else>
                <div class="c-content-item">
                  <div>{{ productionInfo.phase_one_instalments }}</div>
                  <div class="red">
                    ¥{{
                      (productionInfo.oneMonthlypayment + "").replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      ) || 0.0
                    }}
                  </div>
                </div>
                <div class="c-content-item">
                  <div>{{ productionInfo.phase_two_instalments }}</div>
                  <div class="red">
                    ¥{{
                      (productionInfo.twoMonthlypayment + "").replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      ) || 0.0
                    }}
                  </div>
                </div>
                <div class="c-content-item">
                  <div>{{ productionInfo.phase_three_instalments }}</div>
                  <div class="red">
                    ¥{{
                      (productionInfo.threeMonthlypayment + "").replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      ) || 0.0
                    }}
                  </div>
                </div>
              </div>
              <div
                class="c-content-item"
                v-if="!productionInfo.oneMonthlypayment"
              >
                <div>尾款金额</div>
                <div class="red">
                  ¥{{
                    (productionInfo.finalPayment + "").replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ","
                    ) || 0.0
                  }}
                </div>
              </div>
              <!-- <div class="c-content-item">
                <div>年化单利</div>
                <div class="red">¥2,836</div>
              </div> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row class="footer-w c-wraper">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="tips">
            本网站提供金融计算器计算结果仅供参考，该车型金融产品的详细内容与计算结果，可能因产品政策、金融服务公司金融政策,国家补贴政策而发生变化（包含但不限于车型价格或费率变动，详情请咨询当地经销商。
          </div>

          <el-button class="test-drive" @click="testDrive" type="primary">
            <span>即刻预约</span>
          </el-button>
        </el-col>
      </el-row>
    </div>
    
    <Footer v-if="!minip2"></Footer>
    
  </div>
</template>

<script>
import ShareBar from "@/components/ShareBar";
import Header from "@/components/Header";
import platform from 'platform'
import Footer from "@/components/Footer";
const apiUrl = require('@/config/base.js')
import { maidian } from "@/utils/kiaBuriedPoint.js";
import { getUrlKey } from "@/utils/utils.js";
import { isPortraitFun } from "@/utils/utils.js";
export default {
  name: "index",
  components: { Header, Footer,ShareBar },
  data() {
    return {
      coverImg: "",
      carList: [],
      carModelList: [],
      loanPlan: [],
      tipsText: "",
   
      selectCaretName: "",
      firstProportion: 0,
      carTypeId: "",
      form: {
        guidePrice: "",
        id: "",
        firstProportion: 0,
        loanProductsTypeId: "",
        loanProductsInfoId: "",
        loanMonth: "",
        finalProportion: "0",
      },
      productionInfo: "",
      apiUrl: "/bhaf", // https://pre-www.bhaf.com.cn
      currentProduction: "",
      carName: "",
      carModelName: "",
      loading: true,
      copyModelLists: [],
      subTips: "",
      specStype: false,
      compar: [
        [141, 40],
        [130, 39],
        [126, 27],
        [132, 19],
        [117, 29],
        [109, 25],
        [107, 22],
        [93, 20],
        [76, 7],
        [39, 12],
        [37, 3],
      ],
      comparModel: [
      //[queryCarLoan接口的配置id(北现id), GetCarModelsWithCarSeriesInfo接口的的CarModelID, GetCarModelsWithCarSeriesInfo接口的CMSID]
      //狮铂拓界start
      [852,189,1584],
      [864,192,1590],
      [858,191,1587],
      [854,190,1585],
      //狮铂拓界end

      //赛图斯start
      [825,193,1593],
      //下方已存在
      // [645,126,1350],
      // [647,125,1351],
      // [649,130,1352],
      // [712,128,1354],
      // [708,129,1356],
      //赛图斯end

      [809, 188, 1498],
        [808, 186, 1497],
        [806, 185, 1496],
        [804, 184, 1495],
        [803, 183, 1494],
        [801, 182, 1490],

        [790, 62, 1485],
        [788, 70, 1483],
        [786, 61, 1481],
        [784, 60, 1479],
      
        [773, 162, 1467],
        [771, 163, 1459],
        [702, 156, 1407],
        [704, 154, 1403],
        [706, 153, 1401],
        [735, 157, 1411],
        [737, 158, 1415],
        [739, 159, 1420],
        [688, 140, 1384],
        [690, 134, 1382],
        [692, 132, 1376],
        [694, 118, 1374],
        [714, 78, 342_5],
        [716, 77, 342_4],
        [718, 76, 342_3],
        [720, 80, 342_2],
        [740, 79, 342_1],
        [645, 126, 1350],
        [647, 125, 1351],
        [649, 130, 1352],
        [708, 129, 1356],
        [710, 124, 1355],

        [712, 128, 1354],
        [589, 161, 1314],
        [591, 160, 1311],
        [593, 114, 1305],
        [595, 113, 1275],
        [597, 111, 1264],
        [599, 109, 1263],
        [746, 110, 1431],
        [748, 112, 1432],
        [573, 92, 1221],

        [575, 91, 1218],
        [577, 90, 1142],
        [579, 89, 1220],
        [581, 88, 1217],
        [583, 87, 1143],
        [585, 86, 1216],
        [587, 85, 1141],
        [475, 81, "343_1"],
        [477, 82, "343_2"],
        [479, 83, "343_3"],

        [481, 84, "343_4"],
        [722, 62, "338_4"],
        [724, 70, "338_3"],
        [726, 61, "338_2"],
        [728, 60, "338_1"],
        [325, 48, "327_1"],
        [327, 49, "327_2"],
        [153, 11, "330_1"],
        [259, 13, "330_3"],
        [744, 14, "330_2"],
      ],
      productsTypeInfo: [
        {
          carName: "索奈",
          carTypeId: 141,
          carproductionList: [
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              subTitle: "至高可享2年0首付0利息",
              description: "（首付0％起，贷款期限1-5年，每月还款金额相同）",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高7.4万0息，月供逐年递减",
            },
            {
              name: "50:50",
              copyName: "50:50",
              description:
                "首付50%起，贷款期限1年，0息0月供，到期一次性支付尾款",
            },
          ],
        },
        {
          carName: "EV5",
          carTypeId: 130,
          carproductionList: [
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              subTitle: "至高可享3年0首付0利息",
              description: "（首付0％起，贷款期限1-5年，每月还款金额相同）",
            },
            {
              name: "FLEX",
              copyName: "一年保值回购产品(FLEX)",
              description:
                "贷款期限1年，首付20%，尾款80%，日供低至3.5元起，到期更享8折保值回购",
            },
            {
              name: "50:50",
              copyName: "50:50",
              description:
                "首付50%，贷款期限1-2年，每月仅需偿还利息，到期偿还贷款本金及最后一期利息",
            },
          ],
        },
        {
          carName: "EV6",
          carTypeId: 126,
          carproductionList: [
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",

              description:
                //"首付20％起（新能源15%起），贷款期限1-5年，每月还款金额相同",
                "首付0%起，货款期限1-5年，每月还款金额相同",
  },
            {
              name: "50:50",
              copyName: "50:50",
              description:
                "首付50%起，贷款期限1年，0息0月供，到期一次性支付尾款",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高18.4万0息，月供逐年递减",
            },
          ],
        },
        {
          carName: "赛图斯",
          carTypeId: 117,
          carproductionList: [
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高4.3万0息，月供逐年递减",
            },
          ],
        },
        {
          carName: "狮铂拓界",
          carTypeId: 107,
          carproductionList: [
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
            {
              name: "50:50",
              copyName: "50:50",
              description:
                "首付50%起，贷款期限1年，0息0月供，到期一次性支付尾款",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高9.6万0息，月供逐年递减",
            },
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
          ],
        },
        {
          carName: "嘉华",
          carTypeId: 93,
          carproductionList: [
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",

              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高6.8万0息，月供逐年递减",
            },
          ],
        },
        {
          carName: "智跑",
          carTypeId: 132,
          carproductionList: [
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",

              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
            {
              name: "50:50",
              copyName: "50:50",

              description:
                "首付50%起，贷款期限1年，0息0月供，到期一次性支付尾款",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高6.1万0息，月供逐年递减",
            },
          ],
        },
        {
          carName: "奕跑",
          carTypeId: 37,
          carproductionList: [
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
          ],
        },
        {
          carName: "焕驰",
          carTypeId: 39,
          carproductionList: [
            // {
            //   name: "畅融贷",
            //   copyName: "畅融贷",
            //   description:
            //     "首付0%起，货款期限2-5年，每月还款金额相同",
            // },
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
          ],
        },
        {
          carName: "K5",
          carTypeId: 76,
          carproductionList: [
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
            {
              name: "50:50",
              copyName: "50:50",

              description:
                "首付50%起，贷款期限1年，0息0月供，到期一次性支付尾款",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高8.7万0息，月供逐年递减",
            },
          ],
        },
        {
          carName: "K3",
          carTypeId: 109,
          carproductionList: [
            {
              name: "等额本息",
              copyName: "标准产品（等额本息）",
              description:
                "首付0%起，货款期限1-5年，每月还款金额相同",
            },
            {
              name: "阶梯贷",
              copyName: "3年0息阶梯贷",
              description: "贷款期限3年，至高7万0息，月供逐年递减",
            },
            {
              name: "50:50",
              copyName: "50:50",

              description:
                "首付50%起，贷款期限1年，0息0月供，到期一次性支付尾款",
            },
            {
              name: "畅融贷",
              copyName: "畅融贷",
              description:
                "首付0%起，货款期限2-5年，每月还款金额相同",
            },
          ],
        },
      ],
      defaultCarId: "",
      totalPrice: "",
      hasOptional: "",
      modelCode: "",
      documentHeight: 0,
      documentWidth: 0,
      devicePixelRatio: 1,
      currentProName:'',
      isPortrait: isPortraitFun(),
      minip2:false,

    };
  },

  created() {
    if (window.location.href.endsWith("#/")) {
      let b = new URL(window.location.href);
      //处理地址栏数据

      let obj = this.convertQueryStringToObject(b.search.replace("?", "")); //参数对象

      this.defaultCarId = obj.car_id;
      this.totalPrice = obj.totalPrice;
      this.hasOptional = obj.hasOptional;
      this.modelCode = obj.model_code;
    } else {
      var query = this.$route.query;
      this.defaultCarId = query.car_id;
      this.totalPrice = query.totalPrice;
      this.hasOptional = query.hasOptional;
      this.modelCode = query.model_code;
    }

    this.copyCarList = [];
    this.$axios
      .post(`/dyk/api/CARS/GetCarSeriesWithImagePairs`, { Type: "3" })
      .then((res) => {
        if (res.data.statusCode == 200) {
          res.data.data.Lists.map((item) => {
            this.copyCarList = [...this.copyCarList, ...item.Cars];
          });
          this.getModel();
        } else {
          this.$message.error("获取金融产品方案失败");
        }
      });
  },
  computed: {
    carSerName: function () {
      return this.carName + "  " + this.carModelName;
    },
  },
  mounted() {
   
    this.setDocumentHeight();
    window.addEventListener("resize", this.setDocumentHeight);
    
    var cookieMinip2=this.getCookie("minip2")
    if (((getUrlKey("minip") && getUrlKey("minip") == '2')|| cookieMinip2) && this.isPortrait) {
      this.minip2 = true;
    }

  },
  methods: {
    getCookie(name){
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
          // 检查cookie名称是否匹配
          if (cookie.indexOf(name + '=') === 0) {
              // 找到匹配的cookie
              return true;
          }
      }
      // 没有找到匹配的cookie
      return false;
    },
    setDocumentHeight() {
      if( platform.os.family == 'Windows'){
        this.documentHeight = window.screen.height / window.devicePixelRatio;
      this.documentWidth = window.screen.width / window.devicePixelRatio;
      }else{
          this.documentHeight = window.screen.height 
      this.documentWidth = window.screen.width 
      }
      
      
  
    },

   
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    },
    getProductionName(val) {
      var name = "";
      this.productsTypeInfo.map((item) => {
        if (item.carTypeId == val.carTypeId) {
          item.carproductionList.map((v) => {
            if (val.loanProductsTypeName == v.name) {
              name = v.copyName;
            }
          });
        }
      });
      return name;
    },
    getProductionTipsName(val) {
      this.productsTypeInfo.map((item) => {
        if (item.carTypeId == val.carTypeId) {
          item.carproductionList.map((v) => {
            if (val.loanProductsTypeName == v.name) {
              this.currentProName = v.copyName
              item.name = v.copyName
              if (v.subTitle) {
                this.subTips = v.subTitle;
              } else {
                this.subTips = "";
              }
              console.log(v.name,v.description)
              this.tipsText = v.description;
            }
          });
        }
      });
    },
    convertQueryStringToObject(queryString) {
      var obj = {};
      var pairs = queryString.split("&");
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        obj[key] = value;
      }
      return obj;
    },
    resetQuery() {
      this.hasOptional = false;
      this.totalPrice = "";
    },
    getCopyCarModel(id) {
      this.$axios
        .post(`/dyk/api/CARS/GetCarModelsWithCarSeriesInfo`, { Str: id })
        .then((res) => {
          if (res.data.statusCode == 200) {
            // this.productionInfo = res.data.data;
            this.copyModelLists = res.data.data.Lists;
            this.getProduction(this.carTypeId);
          } else {
            // this.$message.error("获取金融产品方案失败");
          }
        });
    },
    async selectProduction(val) {
      this.loading = true;
      this.form.loanMonth = val.loanMonth;
      if (this.form.firstProportion < Number(val.firstProportion)) {
        this.form.firstProportion = Number(val.firstProportion);
      }

      this.form.finalProportion = Number(val.finalProportion);
      this.form.loanProductsInfoId = val.loanProductsInfoId;
      this.firstProportion = Number(val.firstProportion);
      maidian("期数选择  " + this.form.loanMonth);
      await this.getProductionResults();
      //首付金额productionInfo.firstPayment 月供金额productionInfo.monthlySupply 尾款金额productionInfo.finalPayment
      var infoObj={
        firstPayment:this.productionInfo.firstPayment,
        monthlySupply:this.productionInfo.monthlySupply,
        finalPayment:this.productionInfo.finalPayment,
      }
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '金融计算器_贷款期限'+val.loanMonth, JSON.stringify(infoObj), 1]);
    },
    changeSersice(val) {
      this.resetQuery();
      this.loading = true;
      this.carList.map((item) => {
        if (item.id == val) {
          this.compar.map((x) => {
            if (x[0] == item.id) {
              this.getCopyCarModel(x[1]);
            }
          });
          this.carName = item.name;
          maidian("车型选择  " + item.name);
        }
      });

      this.compar.map((x) => {
        if (x[0] == val) {
          this.copyCarList.map((item) => {
            if (x[1] == item.CarSeriesID) {
              this.coverImg = item.Image;
            }
          });
        }
      });
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '金融计算器_车型选择_'+this.carName]);
      // this.getProduction(val);
    },
    changeslider(val) {
      if (this.form.firstProportion < Number(val)) {
        this.form.firstProportion = Number(val);
      }
      this.form.firstProportion = Number(val);
      this.getProductionResults();
      this.loading = true;
      maidian("首付设置  " + this.form.firstProportion);
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '金融计算器_首付比例_'+this.form.firstProportion+'%']);
    },
    changeModel(val) {
      var that = this
      this.resetQuery();
      this.loading = true;
      this.carModelList.map((item,index) => {
        if (val == item.id) {
          this.comparModel.map((v) => {
            if (item.id == v[0]) {
              this.copyModelLists.map((k) => {
                if (k.CarModelID == v[1]) {
                  // item.guidePrice = k.Price;

                  this.form.guidePrice = parseInt(k.Price);
                }
              });
            }
          });
          this.$refs.carousel.setActiveItem(0);
          this.carModelName = item.name;
          maidian("配置选择  " + item.name);
      
            this.loanPlan = that.groupBy(item.loan, "loanProductsTypeId");
        
          
          this.currentProduction = this.loanPlan[Object.keys(this.loanPlan)[0]];

          this.form.loanMonth = this.currentProduction[0].loanMonth;
          this.form.loanProductsInfoId =
            this.currentProduction[0].loanProductsInfoId;
          this.selectCaretName =
            this.loanPlan[
              Object.keys(this.loanPlan)[0]
            ][0].loanProductsTypeName;
          this.form.id = this.currentProduction[0].id;

          this.form.firstProportion = this.firstProportion = Number(
            this.loanPlan[Object.keys(this.loanPlan)[0]][0].firstProportion
          );

          this.form.finalProportion = Number(
            this.loanPlan[Object.keys(this.loanPlan)[0]][0].finalProportion
          );
          this.form.loanProductsTypeId =
            this.loanPlan[Object.keys(this.loanPlan)[0]][0].loanProductsTypeId;
          this.getProductionTipsName(
            this.loanPlan[Object.keys(this.loanPlan)[0]][0]
          );
          this.getProductionResults();
          this.$forceUpdate();
        }
      });
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '金融计算器_配置选择_'+this.carModelName]);
    },
    selectCaret(idx) {
      var val = this.loanPlan[Object.keys(this.loanPlan)[idx]];

      this.currentProduction = val;
      this.form.loanMonth = this.currentProduction[0].loanMonth;
      this.form.loanProductsInfoId =
        this.currentProduction[0].loanProductsInfoId;
      this.selectCaretName = val[0].loanProductsTypeName;
      this.firstProportion = Number(val[0].firstProportion);

      // if (this.form.firstProportion < Number(val[0].firstProportion)) {
      this.form.firstProportion = Number(val[0].firstProportion);
      // }
      this.form.finalProportion = Number(val[0].finalProportion);
      this.form.loanProductsTypeId = val[0].loanProductsTypeId;
      this.getProductionTipsName(val[0]);
      maidian("产品选择  " + this.getProductionName(val[0]));
      // this.getProductionDes(val[0].loanProductsTypeId);
      this.getProductionResults();
    },
    getProductionResults() {
      this.loading = true;
      var form = new FormData();
      form.append("id", this.form.id);
      form.append("loanProductsInfoId", this.form.loanProductsInfoId);
      form.append("loanProductsTypeId", this.form.loanProductsTypeId);
      form.append("guidePrice", this.form.guidePrice);
      form.append("firstProportion", this.form.firstProportion);
      form.append("loanMonth", this.form.loanMonth);
      form.append("finalProportion", this.form.finalProportion);

      this.$axios
        .post(`${apiUrl.apiUrl}/kia-carservice-api/authIgn/bhaf/queryComputingResult`, form)
        .then((res) => {
          this.loading = false;
          this.getProductionName(this.currentProduction[0]).indexOf("阶梯贷") >
          -1
            ? (this.specStype = true)
            : (this.specStype = false);

          if (res.data.status == 200) {
            this.productionInfo = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    changeStep(val) {
      this.form.firstProportion = Number(val);
      maidian("首付设置  " + this.form.firstProportion);
      this.$forceUpdate();
      this.getProductionResults();
    },
    getModel() {
      this.$axios
        .get(`${apiUrl.apiUrl}/kia-carservice-api/authIgn/bhaf/queryCarType?brandId=2`)
        .then((res) => {
          if (res.data.status == 0) {
            this.carList = res.data.data.carTypeList;
            
            //车型删除 sportage
            const carIdToDelete = '107';
            const indexToDelete = this.carList.findIndex(car => car.id === carIdToDelete);
            if (indexToDelete !== -1) {
                this.carList.splice(indexToDelete, 1);
            } 
            const carIdToDeleteNewSportage = '147';
            const indexToDeleteNewSportage = this.carList.findIndex(car => car.id === carIdToDeleteNewSportage);
            if (indexToDeleteNewSportage !== -1) {
                this.carList.splice(indexToDeleteNewSportage, 1);
            } 
            
            //车型删除 赛图斯
            // const carIdToDeleteSeltos = '117';
            // const indexToDeleteSeltos = this.carList.findIndex(car => car.id === carIdToDeleteSeltos);
            // if (indexToDeleteSeltos !== -1) {
            //    this.carList.splice(indexToDeleteSeltos, 1);
            // } 

            //车型删除 奕跑
            // const carIdToDeleteSeltos = '37';
            // const indexToDeleteSeltos = this.carList.findIndex(car => car.id === carIdToDeleteSeltos);
            // if (indexToDeleteSeltos !== -1) {
            //    this.carList.splice(indexToDeleteSeltos, 1);
            // } 
            
            if (this.defaultCarId) {
              this.copyCarList.map((item) => {
                if (item.CarSeriesID == this.defaultCarId) {
                  this.compar.map((v) => {
                    if (v[1] == this.defaultCarId) {
                      this.carTypeId = v[0] + "";
                    }
                  });
                }
              });
            } else {
              this.carTypeId = res.data.data.carTypeList[0].id;
            }

            var id;
            this.carList.map((item) => {
              this.compar.map((v) => {
                if (item.id == v[0]) {
                  this.copyCarList.map((k) => {
                    if (k.CarSeriesID == v[1]) {
                      if (this.carTypeId == v[0]) {
                        this.coverImg = k.Image;
                        this.carName = item.name;
                      }
                      if (v[1] == 25) {
                        item.name = "K3";
                      } else {
                        item.name = k.Name;
                      }
                      item.imagePath = k.Image;
                      //  item.guidePrice = k.Price
                    }
                  });
                }
              });
            });
            this.compar.map((v) => {
              if (v[0] == this.carTypeId) {
                this.getCopyCarModel(v[1]);
              }
            });
          } else {
            this.$message.error("获取车型车系失败");
          }
        });
    },

    getProduction(id) {
      this.$axios
        .get(`${apiUrl.apiUrl}/kia-carservice-api/authIgn/bhaf/queryCarLoan?carTypeId=${id}`)
        .then((res) => {
          if (res.data.status == 200) {
            // 奕跑 对resultList进行过滤和修改
            if (id == 37) {
              // 1. 过滤掉name是'1.4L 趣享手动版'的数据
              res.data.data.resultList = res.data.data.resultList.filter(item => 
                item.name !== '1.4L 趣享手动版'
              );
              // 2. 将name是'1.4L IVT 天窗款'的改成'1.4L IVT 天窗版'
              res.data.data.resultList.forEach(item => {
                if (item.name === '1.4L IVT 天窗款') {
                  item.name = '1.4L IVT 天窗版';
                }
              });
              res.data.data.resultList.forEach(item => {
                if (item.name === '1.4L 趣享自动版') {
                  item.name = '1.4L IVT 趣享自动版';
                }
              });
            }
            if(id == 117 || id == 107){
              // 过滤掉name中包含"选装"且"选装"之后还有其他字符的item
              res.data.data.resultList = res.data.data.resultList.filter(item => {
                const index = item.name.indexOf('选装');
                if (index !== -1) {
                  // 如果"选装"后面还有其他字符，则过滤掉
                  // "选装"的长度是2，所以如果 index + 2 < item.name.length，说明后面还有字符
                  return index + 2 >= item.name.length;
                }
                // 如果不包含"选装"，保留
                return true;
              });
            }

            if(id== 117 || id == 107){
              //去掉‘基础’字符
              res.data.data.resultList.forEach(item => {
                item.name = item.name.replace('基础', '');
              });
            }
            
            this.carModelList = res.data.data.resultList;

            this.loanPlan = this.groupBy(
              res.data.data.resultList[0].loan,
              "loanProductsTypeId"
            );
            var idx = 0;
            if (this.modelCode) {
              this.comparModel.map((item) => {
                if (item[2] == this.modelCode) {
                  this.form.id = item[0] + "";
                  this.carModelList.map((x, index) => {
                    if (x.id == this.form.id) {
                      idx = index;
                      this.loanPlan = this.groupBy(
                        x.loan,
                        "loanProductsTypeId"
                      );
                    }
                  });
                }
              });
            } else {
              this.loanPlan = this.groupBy(
                res.data.data.resultList[0].loan,
                "loanProductsTypeId"
              );
            }
            if (this.totalPrice) {
              this.form.guidePrice = this.totalPrice;
            } else {
              this.comparModel.map((v) => {
                if (this.carModelList[idx].id == v[0]) {
                  this.copyModelLists.map((k) => {
                    if (k.CarModelID == v[1]) {
                      this.form.guidePrice = parseInt(k.Price);
                    }
                  });
                }
              });
            }
            var currentItem = this.loanPlan[Object.keys(this.loanPlan)[0]];
            this.form.id = currentItem[0].id;
            this.carModelName = currentItem[0].name;
            if (id == 37) {
              if (this.carModelName === '1.4L 趣享自动版') {
                this.carModelName = '1.4L IVT 趣享自动版';
              }
            }
            if(id== 117 || id == 107){
              //去掉‘基础’字符
              this.carModelName = this.carModelName.replace('基础', '');
            }
            this.currentProduction = currentItem;
            this.form.loanMonth = this.currentProduction[0].loanMonth;
            this.form.loanProductsInfoId =
              this.currentProduction[0].loanProductsInfoId;
            this.selectCaretName = currentItem[0].loanProductsTypeName;

            this.form.firstProportion = this.firstProportion = Number(
              currentItem[0].firstProportion
            );
            this.form.finalProportion = Number(currentItem[0].finalProportion);
            this.form.loanProductsTypeId = currentItem[0].loanProductsTypeId;
            // this.getProductionDes(currentItem[0].loanProductsTypeId);
            this.getProductionTipsName(currentItem[0]);
            this.$forceUpdate();
            this.getProductionResults();
          } else {
            this.$message.error("获取车型车系失败:" + res.data.message);
          }
        });
    },
    getProductionDes(id) {
      this.$axios
        .get(`${this.apiUrl}/api/queryLoanProduct2?product_id=${id}`)
        .then((res) => {
          if (res.data.status == 200) {
            this.tipsText = res.data.data.loanProductsTypeList[0].description;
          } else {
            this.$message.error("获取车型车系失败:" + res.data.message);
          }
        });
    },
    testDrive() {
      var infoObjSubmit={
        carName:this.carName,
        carModelName:this.carModelName,
        guidePrice:this.form.guidePrice,//指导价格
        currentProName:this.currentProName,//贷款方案
        firstProportio:this.form.firstProportion+"%",//首付比例
        loanMonth:this.form.loanMonth,//贷款期限
        firstPayment:this.productionInfo.firstPayment,//首付金额
        monthlySupply:this.productionInfo.monthlySupply,//月供金额
        finalPayment:this.productionInfo.finalPayment,//尾款金额
      }
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '即刻预约', JSON.stringify(infoObjSubmit)]);
      debugger
      maidian("金融计算器预约试驾  " + "金融计算器预约试驾");
      this.compar.map((item) => {
        if (item[0] == this.carTypeId) {
          if(this.minip2){
            window.open(`/test-drive?car_id=${item[1]}&minip=2`);
          }else{
            window.open(`/test-drive?car_id=${item[1]}`);
          }
        }
      });
    },
    groupBy(array, key) {
      return array.reduce((result, currentItem) => {
        // 使用 key 获取对象属性作为分类的键
        const groupKey = currentItem[key];

        // 初始化分类数组（如果尚未创建）
        if (!result[groupKey]) {
          result[groupKey] = [];
        }

        // 将当前项添加到对应分类的数组中
        result[groupKey].push(currentItem);

        return result;
      }, {});
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  -ms-zoom: 1;
  zoom: 1;
  min-zoom: 1;
  max-zoom: 1;
  user-zoom: fixed;
  -moz-user-zoom: fixed;
  -webkit-user-zoom: fixed;
  -ms-user-zoom: fixed;
}
// .sticky-top {
//   position: relative;
//   top: 78px; /* 设置吸顶的距离 */
//   z-index: 10; /* 确保吸顶元素在其他内容之上 */
// }
.nq5c-wraper {
  display: flex;

  min-height: 100vh;
  flex-direction: column;
  justify-content: space-around;
}
.c-wraper {
  width: 100vw;
  overflow-x: hidden;
  font-family: "KiaSignatureRegular" !important;
}
::v-deep .el-slider__button-wrapper {
  z-index: 0;
}
.carousel-item-wraper {
  border: 1px solid #999999;
  text-align: center;
  height: 100%;
  color: #000000;
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  .small {
    font-size: 14px;
    font-weight: 600;
    height: 35px;
    line-height: 35px;
    background-color: #333333;
    color: #ffffff;
    font-family: "KiaSignatureRegular" !important;
  }
}
::v-deep .el-carousel__indicators {
  display: none;
}
::v-deep .el-carousel__arrow {
  display: none;
}
.icon-arrow {
  width: 40px;
  height: 90px;
  object-fit: cover;
  cursor: pointer;
}
.small-computer {
  .calculator-header {
    height: 110px;
    & h2 {
      font-size: 22px !important;
      margin-bottom: 25px !important;
    }
  }
  .el-form-item {
    padding-bottom: 22px;
  }
  .bg-purple-light {
    height: 160px;
    width: auto;
    margin: 0 auto;
    object-fit: cover;
    display: flex;
    justify-content: center;
  }
  .c-content {
    height: 344px;
    .c-content-item {
      padding: 20px 0 10px 0;
    }
  }
}
::v-deep {
  .el-select {
    width: 100%;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 70px;
    font-size: 14px;
  }
  .el-select .el-input .el-select__caret {
    color: #000000;
  }
  input::placeholder {
    color: #000000;
  }
  .el-slider__button {
    border: 1px solid #cccccc;
    position: relative;
    width: 18px;
    height: 18px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .s-label {
    width: 70px;
    color: #000000;
    font-weight: 600;
    position: relative;
    top: 1px;
  }
  .el-slider__button::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #000000;
    position: absolute;
    top: 4px;
    left: 4px;
  }
  .el-button {
    border-radius: 0;
    font-size: 12px;
  }
  .el-input-group__append {
    padding: 0 10px;
  }
  .el-form-item__content .el-input-group {
    vertical-align: middle !important;
  }
  .el-form-item__label {
    font-size: 16px;
    font-weight: 600;
    font-family: "KiaSignatureRegular" !important;
    color: #000000;
    margin-bottom: 2px;
    padding: 0 0 1px 0 !important;
  }
  .el-form-item__content {
    line-height: 50px;
  }
  .el-input__inner {
    height: 50px;
    font-size: 14px;
    font-weight: 400;
    font-family: "KiaSignatureRegular" !important;
    color: #000000;
    border-color: #cccccc;
    border-radius: 0;
  }
}
.dk-wraper {
  & img {
    float: left;
  }
  .banner {
    width: calc(100% - 100px);
    float: left;
    margin: 0 10px;
  }
}
.bg-purple-light {
  height: 80px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  justify-content: space-between;
  & img {
    height: 100%;
  }
  & span {
    font-size: 14px;
  }
  .car-label {
    font-size: 14px;
    font-weight: 600;
  }
  .flex-right {
    min-width: 150px;
    text-align: left;
  }
  & p {
    font-size: 10px;
    text-align: right;
    color: #999999;
    margin-top: 3px;
  }
}

.c-content {
  background-color: rgba(5, 20, 31, 0.05);
  padding: 20px 30px;
  height: 297px;
  overflow: hidden;
  & h4 {
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    padding-top: 15px;
  }
  .c-content-item {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    padding: 30px 0 20px 0;
    border-bottom: 1px solid rgba(5, 20, 31, 0.1);
    text-align: right;
    div:first-child {
      color: #000000;
    }
    & span {
      font-weight: 600;
    }
    & p {
      font-size: 16px;
    }
    .red {
      // color: rgba(154, 41, 47, 1);
      font-size: 16px;
      font-weight: 500;
    }
  }
}
.c-content-jt {
  .c-content-item {
    padding: 15px 0 7px 0 !important;
  }
  // padding: 0px 30px;
}
.progress-price-tips {
  color: #000000;
  font-size: 14px;

  line-height: 35px;
}
.footer-w {
  margin-top: 20px !important;
  .tips {
    color: rgba(5, 20, 31, 0.5);
    border-bottom: 1px solid rgba(5, 20, 31, 0.1);
    padding-bottom: 15px;
    font-size: 12px;
    text-align: center;
  }
  .test-drive {
    width: auto !important;
    margin: 20px auto;

    display: flex;
    font-size: 16px;
    padding: 10px 50px 10px 50px !important;
  }
}
.calculator-header {
  font-family: "KiaSignatureRegular";
  height: 80px;
  display: flex;
  background-color: #333;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  margin-top: 75px;
  & h2 {
    font-size: 18px;
    margin-bottom: 15px;
  }
  & h3 {
    font-size: 14px;
    color: #ffffff;
    opacity: 0.6;
  }
}

.c-wraper {
  width: 80%;
  margin: 0px auto;
  .el-button {
    width: 100%;
    padding: 8px 0;
  }
}

::v-deep .progress-price {
  display: flex;
  align-items: center;
  .el-input__inner {
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    font-family: "KiaSignatureRegular" !important;
    color: #000000;
  }
  .el-form-item__content {
    line-height: 40px !important;
  }
}
.subTitle {
  font-weight: 600;
  color: #000000;
  font-size: 14px;
  line-height: 35px;
}
.blod {
  font-weight: 600;
}
::v-deep .btn-wraper {
  display: flex;
  justify-content: flex-start;
  .el-button {
    width: 19.2%;
  }
}
::v-deep .progress-price .el-input__inner {
  padding: 0 5px;
  text-align: center;
}

@media (max-width: 1680px) {
  .c-wraper {
    width: 90%;
  }
}

@media (max-width: 768px) {
  .bg-purple-light {
    height: auto;
    margin: 15px 0;
  }
  .nq5c-wraper {
    display: block;
    height: 100%;
  }
  .sticky-top {
    position: relative !important;
  }
  .subTitle {
    font-size: 12px !important;
    display: block;
    font-weight: 600;
    line-height: 18px;
  }
  .icon-arrow {
    width: 30px;
  }
  .dk-wraper .banner {
    width: calc(100% - 70px);
    margin: 0 5px;
  }
  .progress-price-tips {
    font-size: 10px;
    line-height: 18px;
  }
  .progress-price {
    flex-wrap: wrap;
  }
}
@media only screen and (max-width: 767px) {
  h2 {
    font-size: 18px !important;
  }
  .l-height {
    line-height: 50px;
  }
  .small-computer .el-form-item {
    padding-bottom: 0;
  }
  .calculator-header {
    height: 80px;
    margin-top: 0px;
    z-index: 10;
    margin-bottom: 20px;
    & h2 {
      font-size: 18px !important;
      margin-bottom: 5px !important;
    }
  }
  .c-content {
    height: 454px;
  }
  .calculator-header h3 {
    font-size: 14px;
    padding: 0 16px;
    line-height: 22px;
  }
  .c-wraper {
    width: 92%;
    margin: 0 auto;
    margin-top: 60px;
  }
  .el-form {
    padding-top: 0;
  }
  .el-col-xs-24 {
    // padding:  0 !important;
  }
  .footer-w .tips {
    font-size: 14px;
  }
  ::v-deep .progress-price .el-input__inner {
    height: 30px;
    padding: 0 5px;
    text-align: center;
  }
  .sticky-top {
  position: relative;
  top: 78px; /* 设置吸顶的距离 */
  z-index: 10; /* 确保吸顶元素在其他内容之上 */
}
}
</style>


